
export enum StaffPermission {
  // If enabled the user can see other staff member's calendars.
  CanViewOtherCalendars = 'CanViewOtherCalendars',

  // If enabled the user can edit other staff member's calendars.
  CanEditOtherCalendars = 'CanEditOtherCalendars',

  // If enabled the user will be able to see the list of clients.
  CanViewClients = 'CanViewClients',

  // If enabled the user will be able to edit client profiles.
  CanEditClients = 'CanEditClients',

  // If enabled the user will be able to create or edit services.
  CanEditServices = 'CanEditServices',

  // If enabled the user will be able to invite other people as staff members.
  CanInviteStaff = 'CanInviteStaff',

  // If enabled the user will be able to edit the staff roles.
  CanEditStaffRoles = 'CanEditStaffRoles',

  // If enabled the user will be able to edit the business profile.
  CanEditBusinessProfile = 'CanEditBusinessProfile',

  // If enabled the user will be able to edit the portfolio.
  CanEditPortfolio = 'CanEditPortfolio',

  // If enabled the user will be able to edit other staff member's schedule.
  CanEditOtherStaffSchedule = 'CanEditOtherStaffSchedule',
}
